import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m15.3 1.271-14 13.686a.93.93 0 0 0 0 1.368c.2.196.4.294.7.294s.5-.098.7-.294l14-13.686a.93.93 0 0 0 0-1.368.98.98 0 0 0-1.4 0M3.5 6.843c1.9 0 3.5-1.564 3.5-3.422C7 1.564 5.4 0 3.5 0S0 1.564 0 3.421c0 1.858 1.6 3.422 3.5 3.422m0-4.888c.8 0 1.5.684 1.5 1.466s-.7 1.467-1.5 1.467S2 4.203 2 3.421s.7-1.466 1.5-1.466m11 8.798c-1.9 0-3.5 1.564-3.5 3.422 0 1.857 1.6 3.421 3.5 3.421s3.5-1.564 3.5-3.421c0-1.858-1.6-3.422-3.5-3.422m0 4.888c-.8 0-1.5-.684-1.5-1.466s.7-1.467 1.5-1.467 1.5.685 1.5 1.467-.7 1.466-1.5 1.466"
    }, null, -1)
  ]))]))
}
export default { render: render }